export default {"src":"/_next/static/media/0xaeF0d72a118ce24feE3cD1d43d383897D05B4e99.026e644c.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};